<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div class="mb-2">
          <label for="rfname">
            <small>{{ 'First name' | translate }}</small>
          </label>
          <input
            id="rfname"
            class="form-control"
            :class="{ 'is-invalid': 'name' in errors }"
            type="text"
            v-model="first_name"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="mb-2">
          <label for="rflastname">
            <small>{{ 'Last name' | translate }}</small>
          </label>
          <input
            id="rflastname"
            class="form-control"
            :class="{ 'is-invalid': 'last_name' in errors }"
            type="text"
            v-model="last_name"
          />
        </div>
      </div>
    </div>
    <div class="mb-2">
      <label for="remail">
        <small>{{ 'Email' | translate }}</small>
      </label>
      <input
        id="remail"
        class="form-control"
        :class="{ 'is-invalid': 'email' in errors }"
        type="email"
        v-model="email"
        @blur="checkEmailTypo"
      />
      <div v-if="emailSuggestion" class="form-text">
        <small>
          {{ 'Did you mean' | translate }}
          <a href="#" @click.prevent="applySuggestion">{{ emailSuggestion }}</a>?
        </small>
      </div>
      <div class="invalid-feedback">
        <small>
          {{ 'Already have an account?' | translate }}
          <a href="#" @click.prevent="openModal">
            {{ 'Sign in' | translate }}
          </a>
        </small>
      </div>
    </div>
    <div class="mb-2" v-if="!no_checkout_password">
      <label for="rpassword">
        <small>{{ 'Password' | translate }}</small>
      </label>
      <input
        if="rpassword"
        class="form-control"
        :class="{ 'is-invalid': 'password' in errors }"
        type="password"
        v-model="password"
      />
      <small><InputErrors name="password"></InputErrors></small>
    </div>
  </div>
</template>
<script>
import InputErrors from './InputErrors'

const POPULAR_DOMAINS = [
  'gmail.com', 'googlemail.com', 'yahoo.com', 'hotmail.com', 'outlook.com',
  'icloud.com', 'aol.com', 'live.com', 'msn.com', 'protonmail.com',
  'mail.com', 'yandex.com', 'zoho.com', 'gmx.com', 
  'wp.pl', 'onet.pl', 'poczta.onet.pl', 'onet.eu',
  'o2.pl', 'interia.pl', 'interia.eu', 'op.pl', 'vp.pl',
  'gazeta.pl', 
  
]

const POPULAR_TLDS = ['com', 'net', 'org', 'co', 'io', 'edu', 'gov', 'pl', 'com.pl']

function levenshtein(a, b) {
  const matrix = Array.from({ length: a.length + 1 }, (_, i) => [i])
  for (let j = 0; j <= b.length; j++) matrix[0][j] = j
  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      matrix[i][j] = a[i - 1] === b[j - 1]
        ? matrix[i - 1][j - 1]
        : Math.min(matrix[i - 1][j - 1] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j] + 1)
    }
  }
  return matrix[a.length][b.length]
}

function suggestDomain(domain) {
  if (!domain) return null
  let best = null
  let bestDistance = Infinity
  for (const candidate of POPULAR_DOMAINS) {
    const distance = levenshtein(domain.toLowerCase(), candidate)
    if (distance < bestDistance) {
      bestDistance = distance
      best = candidate
    }
  }
  // only suggest if it's close (1-2 edits) and not already correct
  if (best && bestDistance > 0 && bestDistance <= 2) {
    return best
  }
  return null
}

export default {
  data() {
    return {
      emailSuggestion: null,
    }
  },
  components: {
    InputErrors,
  },
  computed: {
    no_checkout_password() {
      return _.get(this.$store.state, 'page.options.no_password_checkout', false)
    },
    errors() {
      return this.$store.state.errors
    },
    first_name: {
      get() {
        return this.$store.state.registrationData.name
      },
      set(name) {
        this.$store.commit('setRegistrationData', { name })
      },
    },
    last_name: {
      get() {
        return this.$store.state.registrationData.last_name
      },
      set(last_name) {
        this.$store.commit('setRegistrationData', { last_name })
      },
    },
    email: {
      get() {
        return this.$store.state.registrationData.email
      },
      set(email) {
        this.$store.commit('setRegistrationData', { email })
      },
    },
    password: {
      get() {
        return this.$store.state.registrationData.password
      },
      set(password) {
        this.$store.commit('setRegistrationData', { password })
      },
    },
  },
  methods: {
    checkEmailTypo() {
      this.emailSuggestion = null
      if (!this.email || !this.email.includes('@')) return

      const [localPart, domain] = this.email.split('@')
      if (!domain) return

      const suggestedDomain = suggestDomain(domain)
      if (suggestedDomain) {
        this.emailSuggestion = `${localPart}@${suggestedDomain}`
      }
    },
    applySuggestion() {
      this.email = this.emailSuggestion
      this.emailSuggestion = null
    },
    openModal() {
      this.$parent.$refs.login.email = this.email
      this.$parent.$refs.login.openModal()
    },
    setView() {
      this.$store.commit('setView', 'login')
    },
  },
}
</script>